/* External Imports */
import React, { useState } from 'react';

/* Built In Imports */
import { Box, Divider, Image, Step, Stepper, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import ProgramRemarkSupport from './ProgramRemarkSupport';

/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const SnapshotJourney = ({ region, lang, sectionContent }) => {
  const [activeStep, setActiveStep] = useState(0); // Track the active step
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'journey-heading'
  );

  return (
    <Box
      bgImg={{
        base: 'none',
        lg: 'https://static.sadhguru.org/d/46272/1733516221-81185-1.png',
      }}
      bgRepeat="no-repeat"
      bgColor="#F7F7F7"
      bgPos="top right"
      pt={{ base: '4rem', md: '8rem' }}
      pb={{ base: '4rem', md: '1rem' }}
      px={'1.25rem'}
      borderRadius="lg"
      color={'#525252'}
      mx="auto"
    >
      {/* Heading */}
      {programHeading && (
        <StructuredTextParser
          str={render(programHeading?.body)}
          fontSize={{ base: '1.625rem', md: '3.125rem' }}
          lineHeight={{ base: '2.11rem', md: '4.25rem' }}
          fontFamily="FedraSansStd-medium"
          textAlign="center"
          maxW={{ base: '100%', md: '70%' }}
          mb={{ base: '31px', md: '82px' }}
          mx="auto"
          className="heading_box"
        />
      )}
      {/* Stepper  */}
      {!isMobile ? (
        <Stepper
          index={activeStep}
          onStepClick={index => setActiveStep(index)}
          colorScheme="teal"
          size="lg"
          orientation="vertical"
          display="flex"
          alignItems="center"
          justifyContent="center"
          maxWidth={{ md: '750px', lg: '920px' }}
          mx="auto"
          gap="0"
        >
          {sectionContent[1]?.cards?.map((list, index) => (
            <>
              {index % 2 === 0 ? (
                <Step key={list.title}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-evenly"
                    width={{ md: '750px', lg: '920px' }}
                  >
                    <Box
                      py={8}
                      width="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <Image
                        pr="2rem"
                        src={list?.thumbnail?.url}
                        alt={list?.thumbnail?.alt}
                      />
                    </Box>

                    <Box width="10%" height="100%">
                      <Divider
                        orientation="vertical"
                        height="100%"
                        width="100%"
                        borderLeftWidth={activeStep === index ? '3px' : '2px'}
                        borderColor={
                          activeStep === index ? '#F37021' : '#F1EBDF'
                        }
                      />
                    </Box>
                    <Box py={8} width="100%">
                      <Text
                        color="#11146E"
                        fontSize="30px"
                        lineHeight="38.92px"
                        fontFamily="FedraSansStd-medium"
                        mb="16px"
                      >
                        {list?.title}
                      </Text>
                      <StructuredTextParser
                        str={render(list?.description?.value)}
                        color="#525252"
                        fontSize="26px"
                        lineHeight="32.5px"
                        fontFamily="FedraSansStd-book"
                      />
                    </Box>
                  </Box>
                </Step>
              ) : (
                <Step key={list.title}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-evenly"
                    width={{ md: '750px', lg: '920px' }}
                  >
                    <Box
                      py={{ base: '2.5rem', md: '8rem' }}
                      width="100%"
                      textAlign="right"
                    >
                      <Box mr="25px">
                        <Text
                          color="#11146E"
                          fontSize="30px"
                          lineHeight="38.92px"
                          fontFamily="FedraSansStd-medium"
                          mb="16px"
                          mr="8px"
                        >
                          {list?.title}
                        </Text>
                        <StructuredTextParser
                          str={render(list?.description?.value)}
                          color="#525252"
                          fontSize="26px"
                          lineHeight="32.5px"
                          fontFamily="FedraSansStd-book"
                          textAlign="right"
                        />
                      </Box>
                    </Box>

                    <Box width="10%" height="100%" mx="1rem">
                      <Divider
                        orientation="vertical"
                        height="100%"
                        width="100%"
                        borderLeftWidth={activeStep === index ? '3px' : '2px'}
                        borderColor={
                          activeStep === index ? '#F37021' : '#F1EBDF'
                        }
                      />
                    </Box>
                    <Box
                      py={{ base: '2.5rem', md: '8rem' }}
                      width="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <Image
                        ml="-25px"
                        src={list?.thumbnail?.url}
                        alt={list?.thumbnail?.alt}
                      />
                    </Box>
                  </Box>
                </Step>
              )}
            </>
          ))}
        </Stepper>
      ) : (
        <Stepper
          index={activeStep}
          onStepClick={index => setActiveStep(index)}
          colorScheme="teal"
          size="lg"
          orientation="vertical"
          display="flex"
          alignItems="center"
          justifyContent="center"
          maxWidth="300px"
          mx="auto"
          gap="0"
        >
          {sectionContent[1]?.cards.map((list, index) => (
            <Step key={list.step}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-evenly"
                width={'300px'}
              >
                <Box width="10%" height="100%">
                  <Divider
                    orientation="vertical"
                    height="100%"
                    width="100%"
                    borderLeftWidth={activeStep === index ? '3px' : '2px'}
                    borderColor={activeStep === index ? '#F37021' : '#F1EBDF'}
                  />
                </Box>
                <Box mb={6}>
                  <Image
                    pr="1rem"
                    src={list?.thumbnail?.url}
                    alt={list?.thumbnail?.alt}
                    w="140px"
                  />
                </Box>

                <Box py={8} width="100%">
                  <Text
                    color="#11146E"
                    fontSize="18px"
                    lineHeight="23.4px"
                    fontFamily="FedraSansStd-medium"
                    mb="8px"
                  >
                    {list?.title}
                  </Text>
                  <StructuredTextParser
                    str={render(list?.description?.value)}
                    color="#525252"
                    fontSize="16px"
                    lineHeight="20px"
                    fontFamily="FedraSansStd-book"
                  />
                </Box>
              </Box>
            </Step>
          ))}
        </Stepper>
      )}

      {/* Second Program Completed Component */}
      <ProgramRemarkSupport
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />
      <style>{`
        .heading_box h2{
          color:#F37021
          }
          .heading_box mark{
            background: none;
            color:#12166F
          }
      `}</style>
    </Box>
  );
};
export default SnapshotJourney;
